import React, { Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { CircularProgress } from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import LuminateLogo from "../assets/images/logo.png";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { fetchJSON } from "helpers/axios";
import axios from "axios";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";

class RetrieveMatric extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      userMode: "",
      step: 1,
      formValues: {
        email: "",
      },
      //   devUrl: "http://localhost:3000/ConfirmNewPassword/",
      //   hostedUrl: "http://odfel-fedpolybida-api.azurewebsites.net/",
      //   rootUrl: "",
    };
  }

  componentDidMount() {
    if (this.props.userMode == "") {
      this.props.history.push("/");
      return false;
    } else {
      if (this.props.userMode == "Alumni") {
        this.setState({
          userMode: "Alumni",
        });
      } else {
        this.setState({
          userMode: this.props.userMode,
        });
      }
    }
  }

  getRootUrl = () => {
    let url = window.location.origin + "/portal/confirmnewpassword/";
    this.setState({ rootUrl: url });
    return url;
  };

  getBaseUrl = () => {
    let webUrl = this.getRootUrl();
    return webUrl === "http://localhost:22246/" ? devUrl : hostedApiUrl;
  };

  validateEmail = (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(e);
  };

  emailHandler = (e) => {
    try {
      let emailValue = document.getElementById("email").value;
      e.preventDefault();
      this.setState({ ...this.state, formValues: { email: emailValue } });
      let email = document.getElementById("email");
      if (!this.validateEmail(emailValue)) {
        email.style.color = "#d23f3f";
      } else {
        email.style.color = "green";
      }
    } catch (e) {
      e;
    }
  };

  sendLink = async () => {
    try {
      let model = {};
      let email = this.state.formValues.email;
      //   let link = this.getRootUrl();
      //   let resetLink = link // this.state.devUrl;

      //this.getRootUrl();
      if (email == "") {
        NotificationManager.error("Email is required");
        return false;
      } else if (!this.validateEmail(email)) {
        NotificationManager.warning("Email is invalid");
        return false;
      } else {
        model = {
          email: email,
          userMode: this.props.userMode,
          step: 1,
          //   resetLink: `${resetLink}`,
        };
      }

      this.setState({ loader: true });
      const endpoint = `/api/ForgotMatricNo?email=${encodeURIComponent(email)}`;

      const response = await fetchJSON(endpoint, {
        method: "GET",
      });
      if (response.Status == "Ok") {
        // (response);
        NotificationManager.success(response.Message, "Success");

        setTimeout(() => {
          window.location.href = "/portal/Alumnisignin";
        }, 1000);
      } else if (response.Status == "NotFound") {
        // (response);
        NotificationManager.error(response.Message);
      } else if (response.Status == "Invalid") {
        NotificationManager.error(response.Message);
      } else {
        NotificationManager.error(response.Message, response.Status);
        response;
      }
      this.setState({
        loader: false,
        formValues: {
          email: "",
        },
      });
    } catch (e) {
      e;
      this.setState({
        loader: false,
      });
      NotificationManager.error("An Error Occurred");
    }
  };

  render() {
    // const ForgotPassword = () => {
    const { width } = this.props;
    const { loader, userMode, email } = this.state;
    return (
      <>
        <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
          <div className="app-login-main-content">
            <div className="app-logo-content d-flex align-items-center justify-content-center">
              <Link className="logo-lg" to="../" title="Luminate">
                <img src={LuminateLogo} alt="FedPolyLogo" title="FedPolyLogo" />
              </Link>
            </div>

            <div className="app-login-content">
              <div className="app-login-header mb-4">
                <h1 className="text-nowrap fs-2">Retrieve Matric No.</h1>
              </div>

              <div className="app-login-form">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.props.showAuthLoader();
                    this.props.alumniSignin({ email });
                  }}
                >
                  <fieldset>
                    <TextField
                      type="email"
                      // id="required"
                      id="email"
                      label={<IntlMessages id="appModule.email" />}
                      fullWidth
                      value={this.state.formValues.email}
                      onChange={this.emailHandler}
                      margin="normal"
                      className="mt-0 mb-4"
                    />

                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <Button
                        onClick={this.sendLink}
                        variant="contained"
                        className="text-white"
                        style={{ background: "#540000" }}
                      >
                        {/* <IntlMessages id="appModule.resetPassword" /> */}
                        Send Mail
                      </Button>

                      <Link
                        to={`../${userMode}signin`}
                        style={{ color: "red" }}
                      >
                        <IntlMessages id="appModule.signIn" />
                      </Link>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          {loader && (
            <div className="loader-view">
              <CircularProgress />
            </div>
          )}
          {/* {showMessage && NotificationManager.error(alertMessage)} */}
          <NotificationContainer />
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { userMode } = auth;
  return { userMode };
};

export default connect(mapStateToProps)(RetrieveMatric);
